import React from 'react';
import {
  SecSubTitle,
  SecTitle,
  InfoMedia,
  Button
} from '../../components';

const AboutSeven = ()=> (
  <div className="background-image" style={{backgroundImage: 'url(images/bg/about-bg-5-1.jpg)'}}>
    <div className="container container-style1">
      <div className="row flex-row-reverse align-items-center gx-70">
        <div className="col-lg-6 col-xl">
          <img src="images/bg/pc-min.png" alt="aboutthumb"/>
        </div>
        <div className="col-lg-6 col-xl-auto">
          <div className="about-box2">
            <SecSubTitle><i className="fas fa-bring-forward"/>Get best EduTech Software</SecSubTitle>
            <SecTitle className="text-capitalize h1">Inspiring Tech Needs for Business</SecTitle>
            <p>Bway Telecom is a leading provider of educational software solutions dedicated to transforming how institutions operate and deliver learning. With a deep understanding of academic workflows and challenges, we develop customizable portal systems that streamline management, improve engagement, and ensure data-driven decision-making.</p>
            <p>Founded on a vision to bridge the gap between education and technology, we’ve helped institutions of all sizes modernize their processes using our robust, user-friendly platforms.</p>
            <div className="row gx-0 align-items-center flex-row-reverse justify-content-end mt-sm-3 pt-sm-3 mb-30 pb-10">
              <div className="col-sm-auto">
                <p className="author-degi">Founders</p>
                <h3 className="h5 author-name">A.J. Adeniji</h3>
                <h3 className="h5 author-name">A.I. Akintola</h3>
              </div>              
              <div className="col-sm-auto">
                <InfoMedia className="about-call"
                  icon="fas fa-phone-alt"
                  title="Call To Ask Any Queary"
                  info={<a href="tel:+25821562154">+(234) 81 344 774 18</a>}
                />
              </div>
            </div>
            <Button path="/service">Order Service<i className="far fa-long-arrow-right"/></Button>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default AboutSeven;